import React from 'react';
import Edit_primary from '../adminIcons/Edit_primary.svg'
import CrossIcon from '../adminIcons/del.svg'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux';
import { deleteCategory } from '../../actions/AdminCategoryActions';
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

const CategoryItem = (props) => {

    const navigate = useNavigate()

    const dispatch = useDispatch()

    const { attributes, listeners, setNodeRef, transform, transition, isDragging  } = useSortable(
        {id: props.category.position})

    const style = {
        transition,
        transform: CSS.Transform.toString(transform),
    }

    const deleteHandler = (e, id) => {
        e.stopPropagation()
        var answer = window.confirm("Are you sure you want to delete this category?");
        if(answer){
            dispatch(deleteCategory(id))
        }
    }

    return (
        <div    
            id={props.category.position}
            ref = {setNodeRef}
            {...attributes}
            {...listeners}
            style = {style}
            className='p-3 border border-secondary rounded d-flex my-2'
            key = {props.index}
            onClick={()=>navigate(`/editCategory/${props.category.id}`)}
            role='button'
            >
            <div className='col-2 d-flex justify-content-center align-items-center'>
                <img  
                    src = {`https://img.cugate.com/?o=CUTV_CATEGORY&i=${props.category.id}&s=mega`} 
                    width='100' 
                    alt = 'bb'/>
            </div>
            <div className = 'text-info col-5 text-center'>{props.category.title}</div>
            <div className = 'col-3 d-flex justify-content-center align-items-center'>
                {
                    props.category.status? 
                    <div className = 'text-info'>ON</div> : <div className = 'text-info'>OFF</div>
                }
            </div>    
            <div className = 'd-flex col-2 justify-content-center'>
                <img 
                    className = 'p-1' 
                    style={{width:"22px"}}
                    src = {Edit_primary}
                    role = 'button'
                    onClick={()=>navigate(`/editCategory/${props.category.id}`)}
                    alt = ""></img>
                <img 
                    className = 'p-1' 
                    role = 'button'
                    style={{width:"36px"}}  
                    src = {CrossIcon}
                    onClick = {(e)=>deleteHandler(e, props.category.id)}
                    alt = ""></img>
            </div>
            
        </div>
    );
};

export default CategoryItem;